var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalFireDepartment = function SvgLocalFireDepartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.5 8.742 1.68 1.68c.39.39.703.86.78 1.406.274 1.524-.937 2.852-2.46 2.852s-2.734-1.328-2.46-2.89c.077-.509.39-.977.78-1.368zm2.969-5.273a.67.67 0 0 1 .898-.117 6.8 6.8 0 0 1 2.656 6.757c-.312 1.875-1.484 3.438-3.085 4.414.585-.859.859-1.914.664-3.046-.157-.86-.625-1.641-1.25-2.227L8.086 6.984a.85.85 0 0 0-1.172 0L4.648 9.211c-.625.625-1.093 1.406-1.25 2.266a4.2 4.2 0 0 0 .664 3.085C2.149 13.392.82 11.283.82 8.82c0-4.18 3.438-7.07 5.39-8.36a.813.813 0 0 1 1.29.665v1.29c0 1.562 1.992 2.265 2.969 1.054"
  })));
};
export default SvgLocalFireDepartment;